
import 'pages/settings/settings-main.tag'
import 'pages/settings/currencies/currencies.tag'
import 'pages/settings/measurements/measurements.tag'
import 'pages/settings/measurements/measure-edit.tag'
import 'pages/settings/paysystems/pay-systems.tag'
import 'pages/settings/paysystems/pay-system-edit.tag'
import 'pages/settings/email/email.tag'
import 'pages/settings/email/email-template-edit.tag'


import 'pages/settings/seo-vars/seo-vars.tag'
import 'pages/settings/add-fields/add-fields.tag'
import 'pages/settings/permissions/permissions.tag'
import 'pages/settings/permissions/permission-rights-edit.tag'
import 'pages/settings/synhro-1c/settings-synhro-1c.tag'
import 'pages/settings/sms/sms.tag'
import 'pages/settings/sms/sms-template-edit.tag'
import 'pages/settings/geotargeting/geotargeting.tag'
import 'pages/settings/geotargeting/geotargeting-edit.tag'
riot.tag2('settings', '  <div class="row">\n    <div class="col-sm-2 hidden-xs" if="{!edit}">\n      <ul class="nav nav-pills nav-stacked" style="height: calc(100vh - 65px); position: fixed; overflow-y: auto; padding-right: 20px; width: 15%;">\n        <li class="{active: name == tab}" each="{tabs}" if="{admin ? isAdmin() : checkPermission(permission, 1000)}"><a href="#settings/{link}">{title}</a></li>\n      </ul>\n    </div>\n    <div class="col-xs-12 hidden-sm hidden-lg hidden-md form-group" if="{!edit}">\n      <select class="form-control" onchange="{menuSelect}">\n        <option each="{tabs}" if="{admin ? isAdmin() : checkPermission(permission, 1000)}" value="{name}" __selected="{name == tab}" no-reorder>{title}</option>\n      </select>\n    </div>\n    <div class="col-sm-10 col-xs-12">\n      <settings-main if="{tab == &quot;&quot;}"></settings-main>\n\n      <pay-systems if="{tab == &quot;pay-systems&quot; &amp;&amp; !edit}"></pay-systems>\n      <email if="{tab == &quot;email&quot; &amp;&amp; !edit}"></email>\n      <currencies if="{tab == &quot;currencies&quot;}"></currencies>\n      <measurements if="{tab == &quot;measurements&quot; &amp;&amp; !edit}"></measurements>\n      <permissions if="{tab == &quot;permissions&quot; &amp;&amp; !edit}"></permissions>\n      <seo-vars if="{tab == &quot;seo-variables&quot;}"></seo-vars>\n      <add-fields if="{tab == &quot;fields&quot;}"></add-fields>\n      <settings-yandex-photos if="{tab == &quot;yandex-photos&quot;}">\n        <h4>Яндекс.Фотки - в разработке</h4>\n      </settings-yandex-photos>\n      <settings-synhro-1c if="{tab == &quot;settings-synhro-1c&quot; &amp;&amp; !edit}"></settings-synhro-1c>\n      <sms if="{tab == &quot;sms&quot; &amp;&amp; !edit}"></sms>\n      <geotargeting if="{tab == &quot;geotargeting&quot; &amp;&amp; !edit}"></geotargeting>\n    </div>\n    <div class="col-md-12">\n\n      <pay-system-edit if="{tab == &quot;pay-systems&quot; &amp;&amp; edit}"></pay-system-edit>\n      <email-template-edit if="{tab == &quot;email&quot; &amp;&amp; edit}"></email-template-edit>\n      <permission-rights-edit if="{tab == &quot;permissions&quot; &amp;&amp; edit}"></permission-rights-edit>\n      <sms-template-edit if="{tab == &quot;sms&quot; &amp;&amp; edit}"></sms-template-edit>\n      <measure-edit if="{tab == &quot;measurements&quot; &amp;&amp; edit}"></measure-edit>\n      <geotargeting-edit if="{tab == &quot;geotargeting&quot; &amp;&amp; edit}"></geotargeting-edit>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();

self.mixin('permissions');
self.tab = '';

route('/settings', function () {
    self.edit = false;
    self.tab = '';
    self.update();
});

route('/settings/*', function (tab) {
    var idx = self.tabs.map(function (item) {
        return item.name;
    }).indexOf(tab);
    var value = void 0;
    if (idx !== -1) value = self.tabs[idx].admin ? self.isAdmin() : self.checkPermission(self.tabs[idx].permission, 1000);
    if (idx !== -1 && value) {
        self.update({ edit: false, tab: tab });
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/settings/measurements/*/([0-9]+)', function (section, id) {
    self.update({ edit: true, tab: 'measurements' });
    observable.trigger('measure-edit', id, section);
});

route('/settings/*/([0-9]+)', function (tab, id) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.update({ edit: true, tab: tab });
        observable.trigger(tab + '-edit', id);
    } else {
        self.update({ edit: true, tab: 'not-found' });
        observable.trigger('not-found');
    }
});

route('/settings/pay-systems/new', function (tab) {
    self.update({ edit: true, tab: 'pay-systems' });
    observable.trigger('pay-systems-new');
});

//route('/settings/delivery/new', tab => {
//    self.update({edit: true, tab: 'delivery'})
//    observable.trigger('delivery-new')
//})

route('/settings/email/new', function (tab) {
    self.update({ edit: true, tab: 'email' });
    observable.trigger('email-new');
});

route('/settings/sms/new', function (tab) {
    self.update({ edit: true, tab: 'sms' });
    observable.trigger('sms-new');
});

route('/settings/geotargeting/new', function (tab) {
    self.update({ edit: true, tab: 'geotargeting' });
    observable.trigger('geotargeting-new');
});

route('/settings..', function () {
    self.update({ edit: true, tab: 'not-found' });
    observable.trigger('not-found');
});

self.tab = '';
self.tabs = [{ title: 'Основные настройки', name: '', link: '', permission: 'settings' },
//{title: 'Доставки', name: 'delivery', link: 'delivery', permission: 'deliveries'},
{ title: 'Платежные системы', name: 'pay-systems', link: 'pay-systems', permission: 'paysystems' }, { title: 'Валюты', name: 'currencies', link: 'currencies', permission: 'currencies' }, { title: 'Меры', name: 'measurements', link: 'measurements', permission: 'settings' }, { title: 'Права доступа', name: 'permissions', link: 'permissions', permission: 'settings', admin: true }, { title: 'SEO переменные', name: 'seo-variables', link: 'seo-variables', permission: 'settings' }, { title: 'Поля', name: 'fields', link: 'fields', permission: 'settings' }, { title: 'Геотаргетинг', name: 'geotargeting', link: 'geotargeting', permission: 'settings' }, { title: 'E-mail уведомления', name: 'email', link: 'email', permission: 'mails' }, { title: 'SMS уведомления', name: 'sms', link: 'sms', permission: 'settings' },
//{title: 'Яндекс.Фотки', name: 'yandex-photos', link: 'yandex-photos', permission: 'settings'},
{ title: 'Интеграция с 1С', name: 'settings-synhro-1c', link: 'settings-synhro-1c', permission: 'settings' }];

self.menuSelect = function (e) {
    return riot.route('/settings/' + e.target.value);
};

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/settings/settings.tag